import { useState } from "react";
import { IControlAttributes, IPageLink } from "../../../base/models";
import { useAuth } from "../../../../modules/auth";
import { useGetProperties } from "../../../base/hooks";
import { ControlType, FetchStatus, IEntity, Property } from "../../../base/types";
import { Registry } from "../../../base/register";
import { UndertakingProperties } from "./properties";
import { useDataContext } from "../../page/context";
import { PageLinkHelper } from "../../../base/helpers";
import { useNavigate } from "react-router-dom";
import { IFieldValue } from "../../../services/models";
import { useUpdateMutation } from "../../../services/data/tableDataApi";

export const UnderTakingComponent = (props: IControlAttributes) => {
  const { control } = props;
  const { properties } = useGetProperties({ bindings: control.bindings });
  const navigateToOnCancel: IPageLink | undefined = properties[Property.CancelPageLink];
  const { setData } = useDataContext();
  const { user, siteId } = useAuth();
  const [loading, setLoading] = useState<string | null>(null);
  const navigate = useNavigate();
  const [updateRecord] = useUpdateMutation();

  const [formState, setFormState] = useState({
    agreement1: false,
    agreement2: false,
  });

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    if (!formState.agreement1 || !formState.agreement2) {
      alert("Please agree to all terms before submitting.");
      return;
    }

    const record: IEntity = {
      slcm_undertaking: 407450001,
    };

    saveFormData(record)
      .then((data) => {
        setData({ type: "Card", result: data, status: FetchStatus.Success });
        if (siteId && navigateToOnCancel && navigateToOnCancel.pageId) {
          navigate(PageLinkHelper.getPageLinkUrl(siteId, navigateToOnCancel));
        }
      })
      .catch((err) => {
        const message =
          err.data?.message || "An error occurred while processing your request. Please try again later.";
        console.error(message);
      })
      .finally(() => setLoading(null));
  };

  const saveFormData = (record: IEntity): Promise<IEntity> => {
    const fields: IFieldValue[] = Object.entries(record)
      .filter(([_, value]) => value !== undefined)
      .map(([field, value]) => ({ field, value, validate: true }));

    return updateRecord({
      portalId: siteId || "",
      userId: user?.contactId,
      tableId: "contact",
      sysId: user?.contactId,
      data: fields,
      triggers: true,
    })
      .unwrap()
      .catch((err) => {
        const message =
          err.data?.message || "An error occurred while processing your request. Please try again later.";
        console.error(message);
        return Promise.reject(message);
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="p-4">
        <div className="form-check mb-3">
          <input
            type="checkbox"
            required={true}
            className="form-check-input"
            id="agreement1"
            name="agreement1"
            checked={formState.agreement1}
            onChange={handleCheckboxChange}
          />
          <label className="form-check-label" htmlFor="agreement1">
            I acknowledge my personal information as below are accurate and can be used
            for all official documents including the transcript and certificate. I will
            raise separate service request in Student Portal for any changes required in
            future.
          </label>
        </div>
        <div className="form-check mb-3">
          <input
            type="checkbox"
            required={true}
            className="form-check-input"
            id="agreement2"
            name="agreement2"
            checked={formState.agreement2}
            onChange={handleCheckboxChange}
          />
          <label className="form-check-label" htmlFor="agreement2">
            I acknowledge that I have received, read and understood the contents of the
            Student Handbook. I agree to abide by the same and understand that EdTech
            University reserve the right to modify and update this handbook from time to
            time.
          </label>
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading !== null}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </>
  );
};

Registry.addControl({
  id: "0d7ac5a6-d3c1-439b-9612-c1001ad48223",
  name: "Undertaking Component",
  type: ControlType.UnderTakingComponent,
  properties: UndertakingProperties,
  component: UnderTakingComponent,
});
